import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/authentication/guards/auth.guard';
import { AppointmentAttachmentListComponent } from './pages/appointment-attachment-list/appointment-attachment-list.component';
import { AppointmentClearCodesComponent } from './pages/appointment-clear-codes/appointment-clear-codes.component';
import { ChargesTabComponent } from './pages/appointment-clear-codes/charges-tab/charges-tab.component';
import { CodesTabComponent } from './pages/appointment-clear-codes/codes-tab/codes-tab.component';
import { NotesTabComponent } from './pages/appointment-clear-codes/notes-tab/notes-tab.component';
import { TimeTabComponent } from './pages/appointment-clear-codes/time-tab/time-tab.component';
import { FormsTabComponent } from './pages/appointment-clear-codes/forms-tab/forms-tab.component';
import { AppointmentDetailsComponent } from './pages/appointment-details/appointment-details.component';
import { AppointmentInventoryComponent } from './pages/appointment-inventory/appointment-inventory.component';
import { InventoryActiveTabComponent } from './pages/appointment-inventory/inventory-active-tab/inventory-active-tab.component';
import { InventoryAddTabComponent } from './pages/appointment-inventory/inventory-add-tab/inventory-add-tab.component';
import { InventoryRemoveTabComponent } from './pages/appointment-inventory/inventory-remove-tab/inventory-remove-tab.component';
import { AppointmentLinecardListComponent } from './pages/appointment-linecard-list/appointment-linecard-list.component';
import { AppointmentListComponent } from './pages/appointment-list/appointment-list.component';
import { AppointmentNotesComponent } from './pages/appointment-notes/appointment-notes.component';
import { LoginComponent } from './pages/login/login.component';
import { TimeTrackingListComponent } from './pages/time-tracking-list/time-tracking-list.component';
import { TruckInventoryListComponent } from './pages/truck-inventory/truck-inventory-list/truck-inventory-list.component';
import { AppointmentLayoutComponent } from './_layout/appointment-layout/appointment-layout.component';
import { MainLayoutComponent } from './_layout/main-layout/main-layout.component';

export const routes: Routes = [
	{
		path: '',
		component: MainLayoutComponent,
		canActivate: [AuthGuard],
		children: [
			{
				path: '',
				redirectTo: 'appointments',
				pathMatch: 'full',
			},
			{
				path: 'appointments',
				component: AppointmentListComponent,
				pathMatch: 'full',
			},
			{
				path: 'time-tracking',
				component: TimeTrackingListComponent,
				pathMatch: 'full',
			},
			{
				path: 'truck-inventory',
				component: TruckInventoryListComponent,
				pathMatch: 'full',
			},
		],
	},
	{
		path: 'appointments/:id',
		component: AppointmentLayoutComponent,
		canActivate: [AuthGuard],
		children: [
			{
				path: '',
				pathMatch: 'full',
				redirectTo: 'details',
			},
			{
				path: 'details',
				component: AppointmentDetailsComponent,
				pathMatch: 'full',
			},
			{
				path: 'inventory',
				component: AppointmentInventoryComponent,
				children: [
					{
						path: '',
						pathMatch: 'full',
						redirectTo: 'active',
					},
					{
						path: 'active',
						pathMatch: 'full',
						component: InventoryActiveTabComponent
					},
					{
						path: 'add',
						pathMatch: 'full',
						component: InventoryAddTabComponent
					},
					{
						path: 'remove',
						pathMatch: 'full',
						component: InventoryRemoveTabComponent
					}
				]
			},
			{
				path: 'clear-codes',
				component: AppointmentClearCodesComponent,
				children: [
					{
						path: '',
						pathMatch: 'full',
						redirectTo: 'codes',
					},
					{
						path: 'codes',
						pathMatch: 'full',
						component: CodesTabComponent,
					},
					{
						path: 'notes',
						pathMatch: 'full',
						component: NotesTabComponent,
					},
					{
						path: 'charges',
						pathMatch: 'full',
						component: ChargesTabComponent,
					},
					{
						path: 'time',
						pathMatch: 'full',
						component: TimeTabComponent,
					},
					{
						path: 'forms',
						pathMatch: 'full',
						component: FormsTabComponent,
					},
				]
			},
			{
				path: 'attachments',
				pathMatch: 'full',
				component: AppointmentAttachmentListComponent,
			},
			{
				path: 'ticket-notes',
				pathMatch: 'full',
				component: AppointmentNotesComponent,
			},
			{
				path: 'linecard',
				pathMatch: 'full',
				component: AppointmentLinecardListComponent,
			},
		],
	},
	{
		path: 'login',
		component: LoginComponent,
		pathMatch: 'full',
	},
	{
		path: '**',
		redirectTo: '',
		pathMatch: 'full',
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			preloadingStrategy: PreloadAllModules,
			// enableTracing: true, // Debug only
		})
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }
